export const APP_MANAGED_ROUTES = {
  LANDING_PAGE: "/",
  HOME: "/home",
  SIGN_IN: "/sign-in",
  SIGN_OUT: "/sign-out",
  ONBOARDING: "/onboarding",
  PRIVACY_POLICY: "/privacy-policy",
  BENEFITS: "/benefits",
  HEALTH_ASSESSMENT: "/health-assessment",
  CARE: "/care",
  // Absolute path matches `PRE_AUTHORIZATIONS_ROUTES.LANDING` from
  // `@leagueplatform/pre-authorizations` so Contentful-emitted deeplinks
  // (`/pre-authorizations`) resolve directly to this page.
  PRIOR_AUTHORIZATIONS: "/pre-authorizations",
  // Details page — same page mounted at TWO paths so both the emblem
  // BE deeplink (`/authorizationsDetails`, emitted by `authorization_
  // requests.go:141`) and the SDK's canonical URL
  // (`/pre-authorizations-details` from `PRE_AUTHORIZATIONS_ROUTES.
  // DETAILS`) resolve to the same view. Only `PRIOR_AUTHORIZATIONS_
  // DETAILS` is used for outbound navigation from emblem code.
  PRIOR_AUTHORIZATIONS_DETAILS: "/authorizationsDetails",
  PRIOR_AUTHORIZATIONS_DETAILS_SDK_ALIAS: "/pre-authorizations-details",
  CLAIMS: "/claims",
  JOURNEY: "/health-journey",
  PROFILE: "/profile",
  MY_PROFILE: "/my-profile",
  MY_PROFILE_PERSONAL_INFORMATION: "/my-profile/personal-information",
  MY_PROFILE_ADDRESS: "/my-profile/address",
  MY_PROFILE_PHONE_AND_EMAIL: "/my-profile/phone-and-email",
  DOCUMENTS: "/documents",
  CARE_PLANS: "/care-plans",
  FORMS: "/forms",
  CARE_MANAGEMENT_FORM: "/care-management-form",
  MEDICATION_COVERAGE_FORM: "/medication-coverage-form",
  COB_INTERSTITIAL: "/cob-interstitial",
  MEDICATION_COVERAGE_INTERSTITIAL: "/medication-coverage-requests",
  COB_FORM: "/cob-form",
  PRE_AUTHORIZATION_INTERSTITIAL: "/pre-authorization-requests",
  PRE_AUTHORIZATION_FORM: "/pre-authorization-request-form",
  PRE_AUTHORIZATION_CHECK_TOOL: "/pre-authorization-check-tool",
  PRE_AUTHORIZATION_CHECK_TOOL_RESULT: "/pre-authorization-check-tool-result",
  STUDENT_CERTIFICATION_FORM: "/student-certification-form",
  SUBMISSION_CONFIRMATION: "/submission-confirmation",
  SUPPORT: "/support",
  MEMBER_SELECTION: "/memberSelection",
  BILLING_AND_PAYMENTS: "/billing-and-payments",
  // BE-emitted deeplink target for any tile that opens chat with a named
  // entry point. The route doesn't render a page — it opens the shared
  // `<Chat>` panel and immediately redirects to /home, so the URL is a
  // side effect.
  LIVE_CHAT: "/live-chat",
  // Human-agent pre-chat questionnaire. The floating support bubble
  // navigates here so the intake questionnaire runs before the chat
  // panel opens.
  LIVE_CHAT_PRE_CHAT: "/live-chat/pre-chat",
  // Base path is `/communication-preferences` (not under `/settings/`) so
  // that Contentful-driven deeplinks like `/communication-preferences/manage-alerts`
  // (emitted from the `manageNotificationsCard` YAML) resolve directly.
  COMMUNICATION_PREFERENCES: "/communication-preferences",
  COMMUNICATION_PREFERENCES_NOTIFICATIONS:
    "/communication-preferences/manage-alerts",
  COMMUNICATION_PREFERENCES_DOC_PREFS_SUCCESS:
    "/communication-preferences/document-preferences-success",
  COMMUNICATION_PREFERENCES_NOTIFICATIONS_SUCCESS:
    "/communication-preferences/manage-alerts-success",
  NOTIFICATIONS: "/notifications",
  ABOUT: "/about",
  // About-me module path, overridden via `routesConfig`. The legacy
  // `/about-me` path redirects here (see `LegacyAboutMeRouteRedirect`).
  MY_HEALTH_DASHBOARD: "/my-health-dashboard",
  CONTACT: "/contact",
  SWITCH_ACCOUNT: "/switch-account",
} as const;

export const {
  LANDING_PAGE: APP_ROOT,
  SIGN_IN,
  SIGN_OUT,
  HOME,
} = APP_MANAGED_ROUTES;

export const ALLOWED_UNAUTHENTICATED_ROUTES: string[] = [
  APP_MANAGED_ROUTES.PRIVACY_POLICY,
];
